import Swiper from "swiper/bundle";

export function initTeamSwipers(scope = document) {
  scope.querySelectorAll("[data-team-root]").forEach((root) => {
    const el = root.querySelector(".js-team-swiper");
    if (!el) return;

    if (el._swiper && typeof el._swiper.destroy === "function") {
      el._swiper.destroy(true, true);
      el._swiper = null;
    }

    let data = {};
    try {
      data = JSON.parse(el.getAttribute("data-options") || "{}");
    } catch (_) {}

    const next = root.querySelector(".team-next");
    const prev = root.querySelector(".team-prev");
    const fill = root.querySelector(".js-team-fill");

    function updateFill(sw, fillEl) {
      if (!fillEl || !sw) return;
      const p = Number(sw.progress);
      const clamped = Number.isFinite(p) ? Math.max(0, Math.min(1, p)) : 0;
      fillEl.style.transform = `scaleX(${0.2 + clamped * 0.8})`;
    }

    el._swiper = new Swiper(el, {
      loop: !!data.loop,
      speed: 500,
      autoplay: data.autoplay
        ? {
            delay: Number(data.delay || 3500),
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          }
        : false,

      slidesPerView: 1.06,
      spaceBetween: 16,
      watchOverflow: true,
      breakpoints: {
        576: { slidesPerView: 1.25, spaceBetween: 16 },
        768: { slidesPerView: 2.15, spaceBetween: 16 },
        992: { slidesPerView: 3, spaceBetween: 32 },
      },

      navigation: next && prev ? { nextEl: next, prevEl: prev } : undefined,
      pagination: {
        el: root.querySelector(".team-pagination"),
        clickable: true,
      },

      on: {
        init() {
          updateFill(this, fill);
        },
        setTranslate() {
          updateFill(this, fill);
        },
        transitionEnd() {
          updateFill(this, fill);
        },
        resize() {
          updateFill(this, fill);
        },
      },
    });

    requestAnimationFrame(() => {
      if (el._swiper) el._swiper.update();
      updateFill(el._swiper, fill);
    });
  });
}

document.addEventListener("DOMContentLoaded", () => initTeamSwipers());